// ZAHAV JEWELRY — Scroll Animations & Interactions
(function () {
  'use strict';

  // Parallax and the container-scroll-reveal both drive transform/opacity via inline
  // styles set on scroll, which would override the CSS prefers-reduced-motion rules in
  // zahav-custom.css (inline styles normally beat stylesheet rules). Skipping the JS
  // entirely for this preference is the only reliable fix; the CSS counterpart shows
  // the finished, static state instead so nothing stays invisible.
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ── Scroll Reveal (IntersectionObserver) ─────────────────────
  function initReveal() {
    const els = document.querySelectorAll('.zahav-reveal');
    if (!els.length) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );
    els.forEach((el) => io.observe(el));
  }

  // ── Piercing card stagger ────────────────────────────────────
  function initPiercingStagger() {
    document.querySelectorAll('.zahav-piercing-nav__grid').forEach((grid) => {
      grid.querySelectorAll('.zahav-piercing-card').forEach((card, i) => {
        card.classList.add('zahav-reveal');
        card.style.transitionDelay = Math.min(i * 0.06, 0.55).toFixed(2) + 's';
      });
    });
  }

  // ── Parallax on existing .zahav-parallax-section ─────────────
  function initParallax() {
    const sections = document.querySelectorAll('.zahav-parallax-section');
    if (!sections.length) return;
    let ticking = false;
    function update() {
      sections.forEach((section) => {
        const img = section.querySelector('.zahav-parallax-section__image');
        if (!img) return;
        const rect = section.getBoundingClientRect();
        const vh = window.innerHeight;
        if (rect.bottom < -vh || rect.top > vh * 2) return;
        const progress = (vh - rect.top) / (vh + rect.height);
        const offset = ((progress - 0.5) * rect.height * 0.32).toFixed(2);
        img.style.transform = `translateY(${offset}px)`;
      });
      ticking = false;
    }
    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  // ── Container Scroll Reveal ──────────────────────────────────
  // Pure typographic entrance: heading wipes in from below, then
  // gold rule extends, sub and CTA fade up — all driven by scroll.
  function initScrollReveal() {
    const sections = document.querySelectorAll('[data-zahav-scroll-reveal]');
    if (!sections.length) return;

    function ease(t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; }
    function rangeEase(a, b, p) {
      return ease(Math.min(Math.max((p - a) / (b - a), 0), 1));
    }

    let ticking = false;

    function update() {
      sections.forEach((section) => {
        const rect      = section.getBoundingClientRect();
        const sectionH  = section.offsetHeight;
        const scrolled  = -rect.top;
        const maxScroll = sectionH - window.innerHeight;
        const p         = Math.min(Math.max(scrolled / maxScroll, 0), 1);

        const heading = section.querySelector('[data-reveal-heading]');
        const rule    = section.querySelector('[data-reveal-rule]');
        const sub     = section.querySelector('[data-reveal-sub]');
        const cta     = section.querySelector('[data-reveal-cta]');
        const hint    = section.querySelector('.zahav-scroll-reveal__scroll-hint');

        if (heading) {
          const t = rangeEase(0, 0.3, p);
          heading.style.transform = `translateY(${((1 - t) * 110).toFixed(1)}%)`;
        }
        if (rule) {
          rule.style.width = `${(rangeEase(0.2, 0.5, p) * 64).toFixed(1)}px`;
        }
        if (sub) {
          const t = rangeEase(0.38, 0.65, p);
          sub.style.opacity   = t.toFixed(3);
          sub.style.transform = `translateY(${((1 - t) * 18).toFixed(1)}px)`;
        }
        if (cta) {
          const t = rangeEase(0.58, 0.82, p);
          cta.style.opacity   = t.toFixed(3);
          cta.style.transform = `translateY(${((1 - t) * 14).toFixed(1)}px)`;
        }
        if (hint) {
          hint.style.opacity = (1 - rangeEase(0, 0.18, p)).toFixed(3);
        }
      });
      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  // ── Shape Hero entrance animation ────────────────────────────
  function initShapeHero() {
    const hero = document.querySelector('.zahav-shape-hero');
    if (!hero) return;
    // The shape is animated by CSS; just trigger reveals immediately
    requestAnimationFrame(() => {
      hero.querySelectorAll('.zahav-reveal').forEach((el, i) => {
        setTimeout(() => el.classList.add('is-visible'), i * 140);
      });
    });
  }

  // ── Video loop fix (iOS Safari ignores loop attribute) ───────
  function initVideoLoop() {
    document.querySelectorAll('.zahav-vs__video, .zahav-vs-r__video').forEach(function(v) {
      v.addEventListener('ended', function() { v.play(); });
    });
  }

  // ── Judge.me cards carousel: 2 cards + arrows on mobile ──────
  function initJudgeMeCarousel() {
    if (window.innerWidth > 749) return;
    var section = document.querySelector('#shopify-section-17798316813ab5cdb9');
    if (!section) return;

    function applyMobileLayout() {
      var widget = section.querySelector('.jdgm-widget.jdgm-cards-carousel');
      var wrapper = section.querySelector('.jdgm-cards-wrapper');
      var cards = section.querySelectorAll('.jdgm-card, .jdgm-media-card');
      if (!widget || !wrapper || !cards.length) return;

      // Calculate card width: 2 cards + gap fitting in viewport
      var gap = 20;
      var pad = 40;
      var cardWidth = Math.floor((window.innerWidth - pad - gap) / 2);

      // Override Judge.me's container-query-driven CSS variables
      widget.style.setProperty('--visible-cards', '2');
      widget.style.setProperty('--card-width', cardWidth + 'px');

      // Override wrapper max-width (set by Judge.me to 1 card's width on mobile)
      wrapper.style.maxWidth = (2 * cardWidth + gap) + 'px';

      // Override each card's dimensions
      cards.forEach(function(card) {
        card.style.setProperty('flex', '0 0 ' + cardWidth + 'px', 'important');
        card.style.setProperty('width', cardWidth + 'px', 'important');
        card.style.setProperty('max-width', cardWidth + 'px', 'important');
      });
    }

    // Watch for Judge.me to inject .jdgm-card elements
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) {
            applyMobileLayout();
            return;
          }
        }
      }
    });
    observer.observe(section, { subtree: true, childList: true });
  }

  // ── Header menu: click-to-open, click-outside-to-close ───────
  function initClickMenu() {
    if (window.innerWidth < 750) return;

    function patchMenu() {
      var header = document.querySelector('header-menu');
      if (!header || header._zahavClickPatched) return;
      header._zahavClickPatched = true;

      // Remove hover triggers from all top-level menu items
      header.querySelectorAll('.menu-list__list-item').forEach(function(item) {
        item.removeAttribute('on:pointerenter');
        item.removeAttribute('on:pointerleave');
      });

      // Suppress the overflowMenu pointerleave that also closes the menu
      var origDeactivate = header.deactivate?.bind(header);
      var menuOpen = false;

      // Override deactivate to be a no-op unless we explicitly want it closed
      if (header.deactivate) {
        header.deactivate = function() {};
      }

      function closeMenu() {
        if (!menuOpen) return;
        menuOpen = false;
        // Temporarily restore deactivate, call it, then suppress again
        if (origDeactivate) {
          header.deactivate = origDeactivate;
          var active = header.querySelector('.menu-list__list-item');
          if (active) active.dispatchEvent(new PointerEvent('pointerleave', { bubbles: false }));
          header.deactivate = function() {};
        }
        // Directly zero the submenu height via the headerComponent property
        var hc = header.closest('header-component');
        if (hc) {
          hc.style.setProperty('--submenu-height', '0px');
          hc.style.setProperty('--full-open-header-height', '0px');
        }
        header.style.setProperty('--submenu-opacity', '0');
        header.ariaExpanded = 'false';
        header.querySelectorAll('.menu-list__link[aria-expanded="true"]').forEach(function(l) {
          l.ariaExpanded = 'false';
        });
      }

      function openMenu(item) {
        // Temporarily restore on:pointerenter so activate fires
        item.setAttribute('on:pointerenter', '/activate');
        item.dispatchEvent(new PointerEvent('pointerenter', { bubbles: false }));
        item.removeAttribute('on:pointerenter');
        menuOpen = true;
      }

      header.addEventListener('click', function(e) {
        var link = e.target.closest('.menu-list__link[aria-haspopup]');
        if (!link) return;
        var item = link.closest('.menu-list__list-item');
        if (!item) return;

        if (menuOpen && link.getAttribute('aria-expanded') === 'true') {
          // Menu already open for this item — let navigation happen naturally
          closeMenu();
          return;
        }
        // First click: open the submenu, don't navigate
        e.preventDefault();
        closeMenu();
        openMenu(item);
      });

      // Close on outside click
      document.addEventListener('click', function(e) {
        if (menuOpen && !header.contains(e.target)) {
          closeMenu();
        }
      });
    }

    if (customElements.get('header-menu')) {
      setTimeout(patchMenu, 150);
    } else {
      customElements.whenDefined('header-menu').then(function() {
        setTimeout(patchMenu, 150);
      });
    }
  }

  // ── Fix "Shop" nav link → /collections/all ───────────────────
  function initShopLink() {
    document.querySelectorAll('a.menu-list__link').forEach(function(a) {
      var title = a.querySelector('.menu-list__link-title');
      if (title && title.textContent.trim() === 'Shop') {
        a.href = '/collections/all';
      }
    });
  }

  // ── Product page: ensure "You may also like" appears before reviews ──
  function initProductSectionOrder() {
    var busy = false;

    function reorder() {
      if (busy) return;
      var recs    = document.querySelector('[id*="product_recommendations"]');
      var reviews = document.querySelector('[id*="17795681923fa0ad9d"]');
      if (!recs || !reviews) return;
      var parent = reviews.parentNode;
      if (!parent || parent !== recs.parentNode) return;
      var kids = Array.from(parent.children);
      var ri = kids.indexOf(reviews);
      var pi = kids.indexOf(recs);
      if (ri === -1 || pi === -1 || pi < ri) return; // already correct
      // reviews is before recs — fix it
      busy = true;
      parent.insertBefore(recs, reviews);
      busy = false;
    }

    reorder();
    var mo = new MutationObserver(reorder);
    mo.observe(document.body, { childList: true, subtree: true });
  }

  // ── Rename "Products" → "Jewelry" on /collections/all ────────
  function initCollectionAllTitle() {
    if (window.location.pathname !== '/collections/all') return;
    document.querySelectorAll('h1').forEach(function(h) {
      if (h.textContent.trim() === 'Products') {
        h.textContent = 'Jewelry';
      }
    });
  }

  // ── Boot ─────────────────────────────────────────────────────
  function init() {
    initPiercingStagger();
    initReveal();
    initVideoLoop();
    initJudgeMeCarousel();
    initClickMenu();
    initShopLink();
    initCollectionAllTitle();
    initProductSectionOrder();
    // Skip scroll-pinning animations in the theme editor to prevent scroll lock, and
    // skip the scroll-tied parallax/translate effects for prefers-reduced-motion.
    if (!document.documentElement.classList.contains('shopify-design-mode') && !prefersReducedMotion) {
      initParallax();
      initScrollReveal();
    }
    initShapeHero();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize when Shopify theme editor reloads a section
  document.addEventListener('shopify:section:load', init);

  // In the theme editor, actively prevent scroll lock
  if (document.documentElement.classList.contains('shopify-design-mode')) {
    function clearScrollLock() {
      document.documentElement.removeAttribute('scroll-lock');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }
    clearScrollLock();
    document.addEventListener('shopify:section:load', clearScrollLock);
    // Watch for scroll-lock being added and immediately remove it
    new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.type === 'attributes' && m.attributeName === 'scroll-lock') {
          document.documentElement.removeAttribute('scroll-lock');
        }
      });
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['scroll-lock'] });
  }
})();
